import React from 'react';
import { Moon, Sun } from 'lucide-react';

interface Props { isDark: boolean; onToggle: () => void; }

export function ThemeToggle({ isDark, onToggle }: Props) {
  return (
    <button
      onClick={onToggle}
      title={isDark ? 'Chế độ sáng' : 'Chế độ tối'}
      style={{
        width: 34, height: 34, borderRadius: 9, flexShrink: 0,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        cursor: 'pointer', transition: 'all 0.15s',
        background: 'var(--bg-card-el)',
        border: '1px solid var(--bd)',
        color: isDark ? '#fbbf24' : '#475569',
      }}
      onMouseEnter={e => { (e.currentTarget as HTMLButtonElement).style.background = 'var(--bg-row-hover)'; }}
      onMouseLeave={e => { (e.currentTarget as HTMLButtonElement).style.background = 'var(--bg-card-el)'; }}
    >
      {isDark ? <Sun size={15} /> : <Moon size={15} />}
    </button>
  );
}
